export class LuggageSize
{
    id:number;
    luggageSizeList:LuggageSizes[];

}
export class LuggageSizes
{
    luggageSizeId:number;
    luggageTypeId:number;
    x:number;
    y:number;
    z:number;
}